module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-16x16-cc2a6c3317426207e720.png";